import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLayoutEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { Dialog, DialogBackdrop, DialogDisclosure, useDialogState } from 'reakit/Dialog';
import styles from './Modal.less';
import { ActionButton, Button } from '$HVUI';
const HVModal = ({ cancelText = 'Cancel', children, closeButtonType = 'link-button', confirmButtonColor = 'ocean', confirmButtonText = 'Confirm', disabled = false, headerText, hideOnClickOutside = true, hideOnEsc = true, hideOpenButton = false, higherModal = false, extraWideModal = false, id = 'hvui-modal', isAlert = false, isOpen = false, modalLabel = 'Modal', onCancel, onClose, onConfirm, onOpen, openButtonColor, openButtonID, openButtonText = 'Open modal', openButtonType = 'primary', openButtonIcon, showConfirmButton = true, showCloseButton = true }) => {
    const hasCloseOrCancel = onCancel || onClose;
    const OpenIcon = openButtonIcon;
    // These props only deviate from their defaults when
    // we have a side effect we have to fire as a result of closing the modal
    // on something other than a submit.
    // While this is provided as an option for completeness, if you find
    // yourself in this situation you should probably rethink the logic of
    // what you're doing.
    const extraDialogProps = {
        baseId: id,
        hideOnEsc: hideOnEsc !== null ? hideOnEsc : hasCloseOrCancel,
        hideOnClickOutside: hideOnClickOutside !== null ? hideOnClickOutside : hasCloseOrCancel,
        preventBodyScroll: false
    };
    const dialog = useDialogState(extraDialogProps);
    // TODO: Refactor Button and ActionButton to TSX, and pass in ref(s)
    // const confirmButtonRef = useRef();
    // // ensure confirm button receives first focus on modal open
    // useEffect(() => {
    //     if (dialog.visible && confirmButtonRef.current) {
    //         // confirmButtonRef.current.focus();
    //     }
    // }, [dialog.visible]);
    useLayoutEffect(() => {
        if (isOpen) {
            dialog.show();
        }
        else {
            dialog.hide();
        }
    }, [isOpen]);
    const isActionButton = openButtonType === 'action-button';
    const OpenButton = isActionButton ? ActionButton : Button;
    return (_jsxs(_Fragment, { children: [_jsx(DialogDisclosure, { ...dialog, onClick: onOpen, children: disclosureProps => (_jsx(OpenButton, { ...disclosureProps, color: isActionButton ? undefined : openButtonColor, disabled: disabled, icon: isActionButton ? OpenIcon : undefined, id: openButtonID, level: isActionButton ? undefined : openButtonType, style: {
                        display: `${hideOpenButton ? 'none' : 'unset'}`
                    }, text: openButtonText })) }), _jsx(DialogBackdrop, { className: styles['modal-backdrop'], ...dialog, onClick: e => {
                    const target = e.target;
                    if (target.className ===
                        'static-React-HVJS-HVUI-Modal-___Modal__modal-backdrop' &&
                        hideOnClickOutside &&
                        typeof onClose === 'function')
                        onClose();
                }, children: _jsxs(Dialog, { ...dialog, "aria-label": modalLabel, role: isAlert ? 'alertdialog' : 'dialog', className: styles[extraWideModal
                        ? 'extra-wide-modal'
                        : higherModal
                            ? 'higher-modal'
                            : 'modal'], hideOnClickOutside: hideOnClickOutside, hideOnEsc: hideOnEsc, onKeyDown: e => {
                        if (e.key === 'Escape' &&
                            hideOnEsc &&
                            typeof onClose === 'function') {
                            onClose();
                        }
                    }, children: [!isAlert && (_jsx("header", { className: styles['close-header'], children: _jsxs("div", { className: styles['header-text-container'], children: [_jsx("span", { children: headerText }), showCloseButton && (_jsx("button", { id: `${id}-close`, type: "button", onClick: () => {
                                            if (typeof onClose === 'function') {
                                                onClose();
                                            }
                                            else if (onClose !== null) {
                                                console.error(`You passed something that isn't a function to an event handler - check the type of onClose`);
                                            }
                                            dialog.hide();
                                        }, "aria-label": "Close", children: _jsx(FiX, { role: "presentation", width: "16px", height: "16px" }) }))] }) })), _jsx("div", { children: typeof children === 'function'
                                ? children({
                                    openModal: dialog.show,
                                    closeModal: dialog.hide,
                                    dialog
                                })
                                : children }), showConfirmButton && (_jsx("div", { className: styles['button-container'], children: showConfirmButton && (_jsxs(_Fragment, { children: [cancelText !== null && (_jsx(Button, { id: `${id}-cancel`, onClick: () => {
                                            if (typeof onCancel ===
                                                'function') {
                                                onCancel();
                                            }
                                            // allow manual overriding of cancel button with isOpen
                                            if (!isOpen) {
                                                dialog.hide();
                                            }
                                        }, level: closeButtonType, style: {
                                            textTransform: 'uppercase'
                                        }, text: cancelText })), _jsx(Button, { id: `${id}-confirm`, onClick: () => {
                                            if (typeof onConfirm === 'function') {
                                                onConfirm({
                                                    closeModal: dialog.hide
                                                });
                                            }
                                            else {
                                                dialog.hide();
                                            }
                                        }, level: "primary", color: confirmButtonColor, text: confirmButtonText })] })) }))] }) })] }));
};
export default HVModal;
